import { ActionSheet } from 'antd-mobile';
import React, { Component } from 'react';
import './ListsCardStyle.less';
import { tools } from 'tplus-voucher';
import { observer, inject } from 'mobx-react';
import {Ticon} from 'tplus-components-mobile';

@observer
export default class ListsCard extends Component {
    constructor(prop) {
        super(prop);
        const { choose = false } = this.props;
        this.state = { choose: choose };
    }

    itemClick = (e) => {
        tools.preventEvent(e);
        const { rowID, itemClick } = this.props;
        itemClick ? itemClick(rowID) : null;
    }

    //更多操作或者选中
    moreClick = (e) => {
        tools.preventEvent(e);
        if (this.props.data.disabled) { // 如果是disabled状态，则返回
            return;
        }
        const { rowID, moreClick, param: { openChoose } } = this.props;
        openChoose ? this.setState({ choose: !this.state.choose }) : null;
        moreClick ? moreClick(rowID) : null;
    }

    iconRender = () => {
        const { data, disabled, param: { openChoose } } = this.props;
        let iconType = 'gengduopoint';
        let iconClass = data.disabled ? ' disabled' : ' notDisabled';
        return (
            data.IsAuth == 'False' ?
                <span className='NotAuth'></span>
                :
                <span className='rightIcon' onClick={this.moreClick}>
                    <Ticon type={iconType} className={iconClass} />
                </span>
        )
    }

    iconRenderCheckbox = () => {
        const { data, disabled, param: { openChoose } } = this.props;
        let iconType = data.choose ? 'yixuan' : 'fuxuankuang';
        let iconClass = data.disabled ? ' disabled' : ' notDisabled';
        return (
            <span className='rightIcon' onClick={this.moreClick}>
                <Ticon type={iconType} className={iconClass} />
            </span>
        )
    }

    detailRender = () => {
        const { data, disabled, param: { openChoose } } = this.props;
        return (
            <div className='text'>
                {data.showItems.map((item, i) => {
                    return <div key={i} style={item.style}>{item.title}</div>
                })}
            </div>
        )
    }

    render() {
        const { data, disabled, param: { openChoose } } = this.props;

        return (
            <div className='listCard' onClick={this.itemClick}>
                {
                    openChoose ?
                        <React.Fragment>
                            {this.iconRenderCheckbox()}
                            {this.detailRender()}
                        </React.Fragment>
                        :
                        <React.Fragment>
                            {this.detailRender()}
                            {this.iconRender()}
                        </React.Fragment>
                }
            </div>
        );
    }
}
